import CurrencyFormatController from './currency-format-controller'

export default CurrencyFormatController
